// globals: jQuery, __setBankAccountInfo

import CashFlowIframeAbstract from './cashFlowIframeAbstract';

var cashFlowIframeSaveUserBank;

(function($) {
    var __setBankAccountPaymentInfo = function(data) {

        const preparedData = {
            accountType: data.account_type,
            accountNumber: data.lastFourDigits,
            paymentProcessorUniqueId: data.token,
            routingNumber: data.bankIdentifier,
        };

        __setBankAccountInfo(preparedData);
    };

    cashFlowIframeSaveUserBank = new CashFlowIframeAbstract({
        frameContainer: 'saveUserCard_i4goFrame',
        iframeLocation: 'profile',
        frameAutoResize: false,
        template: undefined,
        iframeStyle: 'style="width:100%;height:auto;"',
        label: {
            classes:"control-label col-xs-4 text-right",
        }
    });

    var __postToParent = function(data) {
        var parentWindow = window.parent;
        if (parentWindow === window){
            parentWindow = window.opener;
        }

        var parameters = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            parameters[key] = decodeURIComponent(value);
        });

        if (parameters.parentUrl) {
            var parentLocation = parameters.parentUrl;
        }

        if (parentLocation && parentWindow){
            parentWindow.postMessage(data, parentLocation);
        }
    };

    cashFlowIframeSaveUserBank.onSuccess = function(form, data) {
        __setBankAccountPaymentInfo(data);
        __postToParent(data);

        window.close();
    };

    cashFlowIframeSaveUserBank.onFailure = function() {
        $.caAlert('Something went wrong... Please try again later.');
    };

})(jQuery);

export default cashFlowIframeSaveUserBank;
